import React, { useEffect, useState } from 'react';
import { render } from 'react-dom';
import axios from 'axios';

const CitySelector = (props) => {
    const {
        states,
        stateId: defaultStateId,
        countyId: defaultCountyId,
        subcountyId: defaultSubcountyId,
    } = props;

    // selected state, defaulted to incoming data
    const [stateId, setStateId] = useState(defaultStateId);
    const [subcountyId, setSubcountyId] = useState(defaultSubcountyId);

    // fetched data
    const [subcounties, setSubcounties] = useState([]);

    useEffect(() => {
        if (!stateId) return;

        (async () => {
            const { data } = await axios.get('/api/geography/subcounty', { params: { state_id: stateId} });
            setSubcounties(data);
        })();
    }, [stateId]);

    return (
        <div>
            <label htmlFor="filter[state_id]]" className="h4 fw-light">Region</label>
            <div className="mb-3">
                <select
                    className="form-select"
                    name="filter[state]"
                    onChange={e => setStateId(e.target.value)}
                    value={stateId}
                >
                    <option value="" disabled>Select a State / Province</option>
                    {states.map((state) => (
                        <option key={state.id} value={state.id}>{state.name}</option>
                    ))}
                </select>
            </div>
            {stateId && (
                <div className="mb-3">
                    <select
                        className="form-select"
                        name="filter[subcounty]"
                        onChange={e => setSubcountyId(e.target.value)}
                        value={subcountyId}
                    >
                        <option value="" disabled>Select a City</option>
                        {subcounties.map((subcounty) => (
                            <option key={subcounty.id} value={subcounty.id}>{subcounty.name}</option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};

const states = JSON.parse(document.currentScript.getAttribute('data-states')) || [];
const stateId = JSON.parse(document.currentScript.getAttribute('data-state-id') || null) || "";
const countyId = JSON.parse(document.currentScript.getAttribute('data-county-id') || null) || "";
const subcountyId = JSON.parse(document.currentScript.getAttribute('data-subcounty-id') || null) || "";
const node = document.getElementById('county-selector');
render(<CitySelector states={states} stateId={stateId} countyId={countyId} subcountyId={subcountyId} />, node);
